import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { blogApi } from "../../API/Api";
import BlogItem from "./BlogItem";
import BlogNewsItem from "./BlogNewsItem";

const LatestBlogNews = () => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);

  useEffect(() => {
    fetch(
      `https://ghorami.com/profile/login/api_spForum/fun_blog.php?requ_type=allTopBlog`
    )
      .then((res) => res.json())
      .then((result) => {
        setBlogData(result);
      })
      .catch((error) => console.log("BlogData Error => ", error));
  }, []);

  return (
    <Box mt={5}>
      {blogData?.length >= 1 && (
        <Box>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
              px: 2,
              textAlign: "center",
              gap: 1.5,
              mb: 4,
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "26pt", md: "34pt" },
                background: "linear-gradient(to right, #00C9A7, #0074E4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "0.5px",
              }}
            >
              Latest Blog News
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "13pt", md: "15pt" },
                color: "#9E9E9E",
                maxWidth: "600px",
              }}
            >
              Trends and what are future techs to be master in
            </Typography>
          </Stack>
          <Container>
            <Grid container spacing={4} mt={1} mb={4}>
              {blogData.map((element) => (
                <Grid item xs={6} sm={4} md={4} key={element.pic}>
                  <BlogItem blogData={element} key={element.pic} />
                </Grid>
              ))}
            </Grid>
          </Container>

          <Stack direction="row" justifyContent="center" mt={5}>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/bloglist");
              }}
              sx={{
                px: 5,
                py: 1.5,
                fontSize: "16pt",
                fontWeight: 600,
                textTransform: "none",
                background:
                  "linear-gradient(135deg, rgba(0,201,167,0.9), rgba(0,116,228,0.9))",
                borderRadius: "50px",
                boxShadow: "0px 8px 24px rgba(0,201,167,0.3)",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  background:
                    "linear-gradient(135deg, rgba(0,201,167,1), rgba(0,116,228,1))",
                },
              }}
            >
              Load more...
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default LatestBlogNews;
